export const SET_NAME = 'SET_NAME';
export const SET_BIRTH = 'SET_BIRTH';
export const SET_DEATH = 'SET_DEATH';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const SET_TEXT_COLOR = 'SET_TEXT_COLOR';

export const SET_PERSON_ID = 'SET_PERSON_ID';
export const SET_INVERTED = 'SET_INVERTED';

export const BATCH_UPDATE_CELLS = 'BATCH_UPDATE_CELLS';
export const SET_BAND_COLOR = 'SET_BAND_COLOR';


// WEBPACK FOOTER //
// ./src/core/cells/action-types.js